module.exports = __webpack_public_path__ + "0be05cf9d82118a2777b76c3d18e04c4.svg";